import { Notify, Dialog } from 'vant'
import Utils from '@/utils/util'
import I18n from '@/utils/i18n'

const message = {
  descDialog: function({ title, message, className = 'ibps-dialog-desc', confirmButtonColor = '#3396FB', confirmButtonText = '知道了', overlay = true }) {
    Dialog.alert({
      title,
      message,
      confirmButtonColor,
      confirmButtonText,
      overlay,
      className,
      messageAlign: 'left'
    })
  },
  msg: function(message, options) {
    if (!options) {
      options = options || {}
    }
    options.message = message
    Notify(options)
  },
  /**
   * 操作警告提示
   */
  warning: function(message) {
    this.msg(message, {
      type: 'warning'
    })
  },
  /**
   * 操作成功提示
   */
  success: function(message) {
    this.msg(message, {
      type: 'success'
    })
  },
  error: function(message) {
    this.msg(message, {
      type: 'error'
    })
  },
  /**
   * 默认操作成功提示
   *  @param {*} message
   */
  successMessage: function(message = I18n.t('common.dialog.operateSuccess')) {
    this.success(message)
  },
  /**
   * 删除成功提示
   * @param {*} message
   */
  removeSuccessMessage: function(message = I18n.t('common.dialog.removeSuccess')) {
    this.success(message)
  },
  /**
 * 获取选择行的id
 * @param {*} rows
 * @param {*} pkKey
 */
  getSelectedIds: function(rows, pkKey = 'id') {
    const ids = []
    rows.forEach(row => {
      ids.push(row[pkKey])
    })
    return ids
  },

  /**
 * 保存成功提示
 */
  saveSuccessMessage: function(message = I18n.t('common.dialog.operateSuccess'), callback) {
    message = Utils.isNotEmpty(message) ? message : I18n.t('common.dialog.operateSuccess')

    // MessageBox.confirm(message,
    //   I18n.t('common.dialog.title'),
    //   {
    //     type: 'success',
    //     confirmButtonText: I18n.t('common.dialog.saveConfirmButtonText'),
    //     cancelButtonText: I18n.t('common.dialog.saveCancelButtonText'),
    //     closeOnClickModal: false,
    //     callback: (action) => {
    //       const flag = action !== 'confirm'
    //       callback(flag)
    //     }
    //   })
  },

  /**
 * 保存成功提示
 */
  saveSuccessAlert: function(message = I18n.t('common.dialog.operateSuccess'), callback) {
    // MessageBox.alert(message,
    //   I18n.t('common.dialog.title'),
    //   {
    //     type: 'success',
    //     closeOnClickModal: false,
    //     callback: (action) => {
    //       callback(action)
    //     }
    //   })
  },
  /**
 * 保存失败
 */
  saveErrorMessage: function(message, callback) {
    this.warning(message || I18n.t('common.dialog.saveError'))
    if (callback) { callback() }
  }
}

export default message
